import { Text, View } from "react-native";
import {
  UrgentConcernTypeEnum,
  getUrgentConcernTypeLabel,
} from "../../../services/api/types/shiftHandover/enums/UrgentConcernTypeEnum";

interface Props {
  type?: UrgentConcernTypeEnum | null;
}

export function UrgentConcernTypeBadge({ type }: Props) {
  const label = getUrgentConcernTypeLabel(type);

  if (!label) {
    return null;
  }

  return (
    <View className="self-start mb-1 px-2 py-0.5 rounded-full bg-red-100">
      <Text className="text-[10px] font-semibold uppercase text-red-700">
        {label}
      </Text>
    </View>
  );
}
